import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/bd-mobile-next/app/global-error.tsx");
